import { PageHeader } from '@@/PageHeader';
import { Widget, WidgetBody } from '@@/Widget';

import { HelmInstallForm } from './HelmInstallForm';

export function HelmInstallView() {
  return (
    <>
      <PageHeader title="Helm install" breadcrumbs="Helm install" reload />
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>
              <HelmInstallForm />
            </WidgetBody>
          </Widget>
        </div>
      </div>
    </>
  );
}
